<template>

      <div>
        
      <div class="data-row  d-flex align-items-center justify-content-between flex-wrap mb-2">
        <div class="meta-item">
            <span>{{ $t('navigations.data received') }} : {{filterDate(alertDetails.formItemCreatedAt)}} | {{relativeTime(alertDetails.formItemCreatedAt)}}</span>
          </div>
          <div class="meta-item">
            <span>{{$t('navigations.alert triggered')}}: {{ filterDate(alertDetails.createdAt) }} | {{relativeTime(alertDetails.createdAt) }}</span>
          </div>
          <div class="meta-item" v-if="alertDetails.status">
            <span class="meta-badge" :class="{'meta-badge-success':alertDetails.status=='Resolved'}" > {{ $t('navigations.status')}} : {{ alertDetails.status }}</span>   
          </div>
      </div>
      <div class="data-row  d-flex align-items-center flex-wrap mb-2">
        <div class="subject-item">
            <span class="subject-label"> {{ $t('navigations.subject id') }}:&nbsp;<b>{{ alertDetails.subjectCode }}</b></span>
          </div>
          <div class="subject-item">         
            <span class="subject-label"> {{ $t('navigations.site code') }}:&nbsp;<b>{{alertDetails.siteCode }}</b></span>
          </div>
          <!-- <div class="subject-item" v-if="alertItem.Status">
            <span class="subject-label"> {{ alertItem.Status }}</span>        
          </div> -->
      </div>
      <div class="d-flex align-items-center alert-bdr alert-message py-3 mb-2" v-if="alertItem.AlertMessage" :class="{
                    'alert-warning': alertItem.Priority == 'High',
                    'alert-info': alertItem.Priority == 'Moderate',
                    'alert-danger': alertItem.Priority == 'Critical',
                  }">
            <div class="alert-icon ml-2" :class="{
                          'badge-danger':
                            alertItem.Priority == 'Critical',
                          'alert-badge-primary':
                            alertItem.Priority == 'Moderate',
                          'badge-warning': alertItem.Priority == 'High',
                        }">
                <i class="fa fa-bell text-white"></i>
            </div>
            <div class="alert-content" >
                <p class="mb-0">{{ alertDetails.message }}</p>
            </div>
      </div>         
        <h6 class="section-title d-flex align-items-center">
                    {{ $t('navigations.clinical data') }}
        </h6>
        <div class="info-grid mb-3">
            <div class="info-label">{{ $t('navigations.form name') }}:</div>
            <div class="info-value">{{ alertItem.TemplateName ? alertItem.TemplateName : '' }}</div>
            
            <div class="info-label">{{ $t('navigations.field name') }}:</div>
            <div class="info-value">{{ alertItem.FieldName }}</div>
            
            <div class="info-label">{{ $t('navigations.field label') }}:</div>
            <div class="info-value">{{ alertItem.FieldLabel }}</div>
            <div class="info-label">{{ $t('navigations.recorded value') }}:</div>
            <div class="info-value">{{ alertDetails.value }}</div>
            <!-- <div class="info-label">Recorded Value:</div>
            <div class="info-value">
                <span class="highlight-value">5 mg/dL</span>
            </div> -->
            
            <div class="info-label">{{ $t('navigations.alert rule') }}:</div>
            <div class="info-value d-flex"> {{ $t('navigations.condition') }}:&nbsp;&nbsp; <div
              v-for="(rule, idx) in alertItem.Rule" :key="idx"
            class="d-flex"> {{ rule.Condition }}&nbsp;&nbsp;
              {{ $t('navigations.value') }}:&nbsp;
              <span v-for="(val, vIdx) in rule.Value" :key="vIdx"
                >{{ val }}<span v-if="vIdx < rule.Value.length - 1">, </span></span
              >
            </div></div>
            
            <div class="info-label">{{ $t('navigations.alert for') }}:</div>
            <div class="info-value">Field</div>
        </div>   
        <h6 class="section-title">
          {{ $t('navigations.notification details') }}
        </h6>
        <div class="info-grid">
            <div class="info-label">{{ $t('navigations.data source') }}:</div>
            <div class="info-value">{{ alertDetails.dataSource }}
            </div>
            
            <div class="info-label">{{ $t('navigations.notification method') }}:</div>
            <div class="info-value">
              <div
                v-for="(method,notifIndex) in alertItem.NotificationMethod"
                :key="notifIndex"
              >{{ method }}<span v-if="notifIndex < alertItem.NotificationMethod.length - 1">, </span>
              </div>
            </div>          
            <div class="info-label">{{ $t('navigations.recipients') }}:</div>
            <div class="info-value">
                <div class="d-flex flex-wrap recipients-container">
                      <span class="recipient-tag"
                      v-for="(email, idx) in alertItem.NotificationEmail" :key="idx"
                      >{{ email }}<span v-if="idx < alertItem.NotificationEmail.length - 1">
                      </span></span
                    >
                </div>
            </div>
        </div>
      </div> 


</template>
<script src="./viewAlertDetails.js">
</script>
<style scoped>
.priority-badge
{
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: 15px;
}
.meta-badge-success{
    background: hsl(134, 41%, 88%);
    color: #155724;
}
.meta-badge
{
    background: hsl(210, 16%, 93%);
    padding: 2px 10px;
    border-radius: 20px;
    font-weight: 500;
}
.alert-bdr {
  border-left: 4px solid;
}

.alert-badge-primary {
  background-color: hsl(168, 75%, 40%);
  color: hsl(0, 0%, 100%);
}
.alert-message {
        gap: 15px;
}
.info-value {
    font-weight: 600;
    color: hsl(210, 11%, 15%);
    font-size: 0.8rem;
    }
.data-row{
    gap: 30px;
    background: hsl(210, 100%, 97%);
    padding: 5px 20px;
    border-radius: 0px;
    margin-bottom: 4px;
}
.section-title {
    font-weight: 600;
    color: hsl(210, 29%, 24%);
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
    gap: 8px;
    font-size: .9rem;
}
.btn-view {
            background: #1c84c6;
            color: white;
        }
       
        .btn-view:hover {
            background: #005a93;
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
.info-grid {
      display: grid;
      grid-template-columns: 150px 1fr;
      gap: 5px;
      margin-bottom: 4px;
  }
  
  .info-label {
      font-weight: 500;
      color: #6c757d;
      font-size: 0.8rem;
  }
.meta-item{
  gap: 8px;
  font-size: 0.8rem;
  color: hsl(210, 9%, 31%);
        
}
.subject-label {
    font-size: 0.75rem;
}
.fixed-width-table-cell{
  max-width: 65ch;
  white-space: auto;
}
.alert-icon{
  padding: 3px 6px;
  border-radius: 30px;
  text-align: center;
  font-size: 15px;
  line-height: 1.428571429;
  position: relative;

  border: 0px solid hsl(322, 46%, 50%);
}
.alert-query {
  width:32px;
  position: relative;
  height:32px;
  color:#fff;
  padding: 8px;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.2s;
  border: none;
  gap: 8px;
  font-size: 1rem;
  
}
.alert-query-bg
{
  background-color: hsl(45, 100%, 51%);
}
.resolve-alert-bg
{
  background: hsl(168, 75%, 40%);
  color: white;
}

.query-count-alert:empty {
  display: none;
}
.resolve-alert-bg:hover
{
  background-color: hsl(168, 75%, 40%)
}
.query-bg{
  background-color: hsl(216, 98%, 52%)
}
.alert-query-bg:hover{
   background: hsl(39, 100%, 50%)
}
.alert-query:hover {  
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.alert-query .pointer {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius:0.3em;
  padding: 0.1rem 0.8rem;
  right: 33px;
  top:-17px;
  font-size:0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition:visibility 75ms ease-in;
  transition:visibility  75ms  ease-in;
  }

.recipients-container{
  gap: 8px;
}
.recipient-tag
{
  background: #e8f4ff;
  color: #0d6efd;
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
}
.alert-query:hover .pointer {
  visibility: visible;
  -webkit-transition:visibility 0.4s ease-in;
  transition:visibility 0.4s ease-in;
}

.alert-modal-body{
  padding: 25px;
  max-height: 60vh;
  overflow-y: auto;
}
.alert-modal-header{
  padding: 0px 3px;
  background: hsl(210, 17%, 98%);
  border-bottom: 1px solid #e9ecef;
}
.alert-modal-footer{
  padding: 5px 25px;
  background: hsl(210, 17%, 98%);
  border-top: 1px solid #e9ecef;
}
.query-count-alert {
    position: absolute;
    right: -4px;
    top: -10px;
}
.label-warning-alert {
    background-color: #f8ac59;
    color: #FFFFFF;
    font-size: 10px;
    padding: 2px 4px;
}
</style>